<template>
  <v-dialog v-model="showModal" persistent max-width="700px">
    <v-card>
      <v-card-title class="modalTitle pb-3 mb-3">
        <h2>{{ showTitle }}</h2>
      </v-card-title>

      <v-card-text>
        <v-row no-gutters>
          <v-col cols="12">
            {{ showText }}
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button @click.native="cancelData()">
          Atšaukti
        </el-button>
        <el-button primary @click.native.stop="saveData()">
          Saugoti
        </el-button>
        <el-button primary @click.native.stop="confirmData()">
          Tęsti
        </el-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'UnsavedData',
  props: {
    title: String,
    text: String,
    action: String,
    item: Object,
    value: Boolean,
  },
  data() {
    return {}
  },
  computed: {
    showTitle() {
      return this.title ?? 'Neišsaugoti duomenys'
    },
    showText() {
      return this.text ?? 'Yra neišsaugotų duomenų. Ar norite tęsti?'
    },
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    modalAction() {
      return this.action ?? 'UnsavedData'
    },
  },
  methods: {
    confirmData() {
      this.$root.$emit('confirm' + this.modalAction)
      this.closeModal()
    },
    saveData() {
      this.$root.$emit('save' + this.modalAction)
      this.closeModal()
    },
    cancelData() {
      this.$root.$emit('cancel' + this.modalAction)
      this.closeModal()
    },
    closeModal() {
      this.showModal = false
    },
  },
}
</script>
<style lang="scss" scoped></style>
